jQuery('.imageset_categories').on('change', function(e) {
    var id = jQuery(this).val();
    jQuery.post( ajax_url, {action : 'change_category', id : id},function(result){
        jQuery('.featured_content_sidebar_posts').html(result.data);
      });
});

jQuery(document).ready(function () {

    if(jQuery(window).width() >= 1024){
        // var h = jQuery('.canvas__holder').outerHeight(true) + jQuery('.content__top').outerHeight(true) + 6;
        // jQuery('.featured_content_sidebar').height(h);

        var h = jQuery('.canvas__holder').outerHeight(true);
        jQuery('.featured_content_sidebar').height(h);

        var margin_top =  jQuery('.content__top').outerHeight(true) + 6;
        jQuery('.featured_content_sidebar').css('margin-top', margin_top);

        jQuery('.imageset_categories').on('change', function(e) {
          var id = jQuery(this).val();
          var sidebar_posts = jQuery('.featured_content_sidebar').outerHeight(false) - jQuery('.select2-container').outerHeight(true);

          console.log(jQuery('.featured_content_sidebar_posts').outerHeight());

          jQuery.post( ajax_url, {action : 'change_category', id : id},function(result){
              jQuery('.featured_content_sidebar_posts').html(result.data);

              if(jQuery('.featured_content_sidebar_posts').outerHeight() > sidebar_posts){
                        jQuery('.featured_content_sidebar_posts').css("overflow-y", "scroll");
                        console.log(sidebar_posts);
                        jQuery('.featured_content_sidebar_posts').height(sidebar_posts);
                        console.log(jQuery('.featured_content_sidebar_posts').height());
              } else {
                        jQuery('.featured_content_sidebar_posts').css("overflow-y", "unset");
                        jQuery('.featured_content_sidebar_posts').height("auto");
              }
            })
        })
    }

    jQuery('.spinner__holder').width(jQuery('.canvas__holder').width());
    jQuery('.spinner__holder svg').height(jQuery('.canvas__holder').height());

})

jQuery(window).on('resize', function(){
  jQuery('.spinner__holder').width(jQuery('.canvas__holder').width());
  jQuery('.spinner__holder svg').height(jQuery('.canvas__holder').height());
})
